(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    

setTimeout(() => {
  const addToCart  = document.querySelector('form[action*="/cart/add"] [type="submit"]');
  const fixedAdd   = document.getElementById("fixedAddToCart");
  const fixedBuy   = document.getElementById("fixedBuyNow");
  const stickyWrap = document.querySelector(".sticky-bottom-addtocart");
  const footer     = document.querySelector("footer");
  const media      = document.querySelector(".grid.grid--product-images--partial");

  if (!addToCart || !fixedAdd || !fixedBuy || !stickyWrap || !footer || !media) return;

  fixedAdd.addEventListener("click", () => addToCart.click());
  const realBuyNow = document.querySelector(".sr-headless-checkout");
  if (realBuyNow) fixedBuy.addEventListener("click", () => realBuyNow.click());

  let footerVisible = false;
  let atcVisible = false;
  let mediaVisible = false;

  const updateState = () => {
    const shouldHide =
      footerVisible ||
      mediaVisible ||     
      atcVisible;        

    stickyWrap.style.display = shouldHide ? "none" : "block";
    stickyWrap.style.opacity = shouldHide ? "0" : "1";
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target === footer) footerVisible = entry.isIntersecting;
      if (entry.target === addToCart) atcVisible = entry.isIntersecting;
      if (entry.target === media) mediaVisible = entry.isIntersecting;
    });
    updateState();
  }, { threshold: 0.2 });

  observer.observe(footer);
  observer.observe(addToCart);
  observer.observe(media);

}, 1000);


  } catch(e) { console.error(e); }
})();
})();
